import React from 'react';
import { TrendingUp } from 'lucide-react';

export const EmptyView: React.FC = () => {
  return (
    <div className="flex-1 flex items-center justify-center">
      <div className="text-center max-w-md">
        <TrendingUp className="w-12 h-12 text-gray-400 mx-auto mb-4" />
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          睡眠データの可視化
        </h3>
        <p className="text-gray-600">
          左側のメニューからユーザIDと期間または日付を指定して、睡眠データのグラフを表示できます。
        </p>
      </div>
    </div>
  );
};
